import { BasicController } from "@goodgamestudios/core";

export class BasicData {
    protected _nextUpdateInterval: number = 0;
    protected _updateInterval: number = 1000;

    protected get controller(): BasicController {
        return BasicController.getInstance();
    }
}
